module.exports = __webpack_public_path__ + "img/about/80243-012.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-012.png
// module id = 22
// module chunks = 0